import { getIsoDate } from "../../../../packages/date/dateFunctions.js";
import { Month } from "./Month.js";
import { validateMonth } from "./validateMonth.js";
import { validateYear } from "./validateYear.js";

/**
 * Returns the last date of the month in ISO format.
 */
export const getLastDateOfMonth = (year: string, month: Month) => {
  validateYear(year);
  validateMonth(month);

  const intYear = parseInt(year);
  const intMonth = parseInt(month);

  return getIsoDate(new Date(Date.UTC(intYear, intMonth, 0)));
};
